// extracted by mini-css-extract-plugin
module.exports = {"Container":"StatusCard_Container__sKAWu","Icon":"StatusCard_Icon__FSd_S","Label":"StatusCard_Label__Jd6rW","Count":"StatusCard_Count__A_yUU","Arrow":"StatusCard_Arrow__nukk8"};